<template>
  <span class="mr-2">
    <VTooltip theme="baseTooltip">
      <button
        type="button"
        class="btn p-1 rounded-circle"
        :aria-label="t('view_my_favorites')"
        :title="t('view_my_favorites')"
        @click.prevent="productsStore.toggleFilter('favorites')"
      >
        <span class="sr-only">{{ t('view_my_favorites') }}</span>
        <i
          v-if="isFavoritesInFilter"
          class="mi-heart-fill icon-favorite text-danger"
        />
        <i
          v-else
          class="mi-heart icon-favorite text-primary"
        />
      </button>
      <template #popper>{{ t('view_my_favorites') }}</template>
    </VTooltip>
  </span>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useProductStore } from '@/stores/ProductStore'

const productsStore = useProductStore()
const { isFavoritesInFilter } = storeToRefs(productsStore)

const { t } = useI18n()
</script>

<style lang="scss">
.icon-favorite{ font-size: 28px; }
</style>

<i18n>
  {
    "cs": {
    "view_my_favorites": "Zobrazit moje oblíbené"
},
    "sk": {
    "view_my_favorites": "Zobraziť moje obľúbené"
},
    "pl": {
    "view_my_favorites": "Zobacz moje ulubione"
},
    "hu": {
    "view_my_favorites": "Mutasd a kedvenceimet"
},
    "de": {
    "view_my_favorites": "Meine Favoriten ansehen"
},
    "at": {
    "view_my_favorites": "Meine Favoriten ansehen"
},
    "ro": {
    "view_my_favorites": "Arată favoritele mele"
},
    "fr": {
    "view_my_favorites": "Afficher mes favoris"
}
  }
</i18n>
